import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaReportTypes } from './sagaReportRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import { getStateItem } from '../../helpers/utility';

export function* requestInitialPropertyReport() {
    const tag = '[REQUEST_INITIAL_PROPERTY_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId && culture) {
            // step 2 : validation passed..
            const response = yield call(
                API.requestInitialPropertyReport,
                jwtToken,
                branchId,
                culture
            );
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(
                    `${tag} requestInitialPropertyReport response :`,
                    response.data
                );
                yield put(
                    Actions.initialPropertyReportSuccess(response.data.result)
                );
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    } catch (e) {
        console.warn(
            `${tag} requestInitialPropertyReport failed with error :`,
            e
        );
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.initialPropertyReportFailure(message));
    }
}

export function* requestGeneratePropertyReport(action) {
    const tag = '[REQUEST_GENERATE_PROPERTY_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const currentOffice = getStateItem('SagaAuth', 'currentOffice');
        const isBCP =
            currentOffice &&
            currentOffice.officeName.toLowerCase().indexOf('bcp') > -1
                ? true
                : false;
        if (jwtToken && branchId && culture) {
            // step 2 : validation passed..
            const response = yield call(
                API.requestGeneratePropertyReport,
                jwtToken,
                branchId,
                culture,
                action.selectedFilter,
                isBCP
            );
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(
                    `${tag} requestGeneratePropertyReport response :`,
                    response.data
                );
                // popup new window for open/download excel, pdf file
                window.open(response.data.result, '_blank');
                yield put(
                    Actions.generatePropertyReportSuccess(response.data.result)
                );
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    } catch (e) {
        console.warn(
            `${tag} requestGeneratePropertyReport failed with error :`,
            e
        );
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generatePropertyReportFailure(message));
    }
}

export function* requestGenerateSaleReport(action) {
    const tag = '[REQUEST_GENERATE_SALE_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateSaleReport, jwtToken, branchId, culture, action.saleReportInput, action.userId, action.exportType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(
                    `${tag} requestGenerateSaleReport response :`,
                    response.data
                );
                   // popup new window for open/download excel, pdf file
                   window.open(response.data.result, '_blank');
                yield put(
                    Actions.generateSaleReportSuccess(response.data.result)
                );
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    } catch (e) {
        console.warn(`${tag} requestGenerateSaleReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateSaleReportFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(
            SagaReportTypes.REQUEST_INITIAL_PROPERTY_REPORT,
            requestInitialPropertyReport
        ),
        takeLatest(
            SagaReportTypes.REQUEST_GENERATE_PROPERTY_REPORT,
            requestGeneratePropertyReport
        ),
        takeLatest(
            SagaReportTypes.REQUEST_GENERATE_SALE_REPORT,
            requestGenerateSaleReport
        )
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaReport/sagaReportSaga.ts